import { useCallback, useEffect, useState } from "react";
import { Button, Col, Container, Form, Row, Spinner } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import useFetch from "../../../../hooks/useFetch";

//interfaces
import { TipoServicioInterface } from "../../../../interfaces/TipoServicioInterface";
import ForbiddenMessage from "../../../Mensajes/ForbiddenMessage";
import SuccessMessage from "../../../Mensajes/SuccessMessage";
import ServerMessage from "../../../Mensajes/ServerMessage";

//estilos
const classes = require("./TipoServicioEdit.module.css").default;

/**
 * UusarioEdit Component
 * @description: Componente que permite editar un tipoServicio.
 * @date 6/12/2022.
 * @param Props Ninguno
 * @returns JSX de la tabla de tipoServicios.
 */

const TipoServicioEdit = () => {
  const { idTipoServicio } = useParams();
  const { sendRequest, error, setError, serverMessage, setServerMessage } =
    useFetch();
  const [tipoServicio, setTipoServicio] = useState<TipoServicioInterface>();
  const [show, setShow] = useState(false);

  //Variables de formulario
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    control,
  } = useForm({
    defaultValues: {
      nombre: tipoServicio?.nombre,
      revision: tipoServicio?.revision,
    },
  });

  //Función que trata el detalle de tipoServicio.
  const transformData = useCallback(
    (variable: any) => {
      setTipoServicio(variable.data);
      reset(variable.data);
    },
    [reset]
  );

  //Se recibe el tipoServicio a editar
  useEffect(() => {
    sendRequest(
      {
        url: `/tipo_servicio/${idTipoServicio}`,
      },
      transformData
    );
  }, [idTipoServicio, sendRequest, transformData]);

  //Función que solicita la edición del tipoServicio
  const updateTipoServicio = (data: any) => {
    sendRequest(
      {
        url: `/tipo_servicio/${idTipoServicio}`,
        method: "PATCH",
        body: data,
      },
      (variable: any) => {
        setShow(true);
      }
    );
  };

  //Mientras se carga el contenido se muestra un spinner
  if (!tipoServicio) {
    return (
      <div className={classes.spinnerContainer}>
        <Spinner animation="grow" variant="info" />
      </div>
    );
  }

  return (
    <Container>
      <h2>Edición del tipo de servicio {idTipoServicio}</h2>
      {/** Alerta de guardado */}
      {show && (
        <SuccessMessage
          header="Tipo de servicio actualizado"
          body="El tipo de servicio ha sido actualizado de manera correcta."
          onCloseHandler={() => setShow(false)}
        />
      )}
      {/** Error del servidor */}
      {serverMessage && (
        <ServerMessage
          message={serverMessage}
          onCloseHandler={() => setServerMessage(undefined)}
        />
      )}
      {error === 403 && (
        <ForbiddenMessage onCloseHandler={() => setError(null)} />
      )}
      {/** Formulario */}
      <Form onSubmit={handleSubmit(updateTipoServicio)}>
        <Row className="mb-3">
          <Form.Group as={Col} md="12" className="mb-3">
            <Form.Label>Nombre</Form.Label>
            <Controller
              name="nombre"
              control={control}
              rules={{
                required: true,
                maxLength: 200,
              }}
              render={({ field }) => {
                return (
                  <Form.Control
                    {...field}
                    onChange={(e) =>
                      field.onChange(e.target.value.toUpperCase())
                    }
                  />
                );
              }}
            />
            {errors.nombre && (
              <Form.Text style={{ color: "red" }}>
                El nombre es obligatorio y no puede ser mayor a 200 caracteres.
              </Form.Text>
            )}
          </Form.Group>
        </Row>
        <Form.Group className="mb-3">
          <Form.Check
            label="¿Este servicio es una revisión?"
            style={{ textAlign: "left" }}
            {...register("revision")}
          />
        </Form.Group>

        <Button
          style={{ backgroundColor: "#21618C", borderColor: "white" }}
          type="submit"
        >
          Guardar cambios
        </Button>
      </Form>
    </Container>
  );
};

export default TipoServicioEdit;
